import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4","key":"svg-0"}],["path",{"d":"M9 15l-4.5 4.5","key":"svg-1"}],["path",{"d":"M14.5 4l5.5 5.5","key":"svg-2"}]]

/**
 * IconPin
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGluIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSA0LjVsLTQgNGwtNCAxLjVsLTEuNSAxLjVsNyA3bDEuNSAtMS41bDEuNSAtNGw0IC00IiAvPgogIDxwYXRoIGQ9Ik05IDE1bC00LjUgNC41IiAvPgogIDxwYXRoIGQ9Ik0xNC41IDRsNS41IDUuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/pin
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPin = createReactComponent('outline', 'pin', 'Pin', __iconNode);

export default IconPin;